import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import DropDownMenu from '../components/DropDownMenu';
import MDEditor from '@uiw/react-md-editor';
import _ from 'lodash';
import { fetchQuestionnaireById, updateQuestionnaireById } from '../../services2/questionnaires.service';
import { adminFetchQuestionnairesData } from '../../services2/studentMissions.service';

const isMobile = window.innerWidth < 1024

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)

    const fetchData = async () => {
        let result = await fetchQuestionnaireById(props.token.token, id);
        if (result.result) {
            setdata(result.result)
        } else {
            alert('Fetch data error')
        }
    }

    const refresh = async () => {
        if (isLoading) return
        setisLoading(true)
        await fetchData(true)
        await fetchQuestionnaireData()
        setisLoading(false)
    }

    const [total, settotal] = useState(0)
    const [questionnaires, setquestionnaires] = useState([])
    const fetchQuestionnaireData = async () => {
        if (!id) return
        let result = await adminFetchQuestionnairesData(props.token.token, id);
        if (result.result) {
            console.log(result.result)
            setquestionnaires(result.result?.questionnaires2 || [])
            settotal(result?.result?.totalCount || 0)
        }
    }

    useEffect(() => {
        refresh()
    }, [id])





    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            {/*buttons*/}
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { 
                    // navigate('/platform2/questionnaires') 
                    navigate(-1)
                }}>{`<`} 返回</div>
                <div className='flex flex-row gap-[8px] flex-wrap '>
                </div>
            </div>
            {/*end of buttons*/}

            <div className='w-full flex flex-row gap-[8px] mt-[16px] flex-wrap'>
                <div className='w-full flex flex-row gap-[64px] flex-wrap w-full'>
                    <div className='font-[700] min-w-[300px]'>問卷名稱: {data?.name || ''}</div>
                    <div className='font-[700] min-w-[300px]'>時間: {data?.time_2 || '-'} 分鐘</div>
                    <div className='font-[700] min-w-[300px]'>問題數量: {data?.questionnaires2?.length || 0}</div>
                    <div className='font-[700] min-w-[300px]'>填寫人數: {total || 0}</div>
                </div>
            </div>


            {questionnaires?.map((questionnaire, index) =>
                <div key={questionnaire.id || index} className='w-full mb-[64px]' style={{}}>
                    <div className='font-[700] mt-[16px]'>問題 {index + 1}</div>
                    {['短句作答題'].includes(questionnaire.type) || <MDEditor.Markdown source={questionnaire?.question || ''} style={{ fontSize: isMobile ? 16 : 25, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />}
                    {['選擇題', '選擇題 + 短句作答題'].includes(questionnaire.type) &&
                        <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                            {questionnaire?.options?.map((option, optionIndex) => (
                                <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                        <button onClick={() => {}}
                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.isSelected ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                        ></button>
                                    </div>
                                    {option.text}  [ {option.count||0} ({Math.round((option.count || 0) / (questionnaire?.totalCount || 1) * 100)}%) ]
                                </div>
                            ))}
                        </div>
                    }
                    {['短句作答題', '選擇題 + 短句作答題'].includes(questionnaire?.type) && (
                        <div className='w-fill mt-[16px] flex flex-col p-[2px]'>
                            <MDEditor.Markdown source={questionnaire?.questionShortanswer || ''} style={{ fontSize: isMobile ? 16 : 25, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />
                            <div className='font-bold mt-[16px]'>填寫人數: {questionnaire.totalCount||0}</div>
                            <div className='w-full flex flex-row flex-wrap gap-[8px] text-[10px] mt-[8px]'>
                                {questionnaire?.answers?.map((answer, answerIndex) =>
                                    <div className='bg-white rounded-[4px] px-[4px] flex flex-row' key={answerIndex}>{answer}</div>
                                )}
                            </div>
                        </div>
                    )}
                    {/*end of open end question*/}

                    {['表格問題'].includes(questionnaire?.type) &&
                        <div className='w-fill mt-[16px] flex flex-col p-[2px] gap-[16px]'>
                            <div className='w-full flex flex-row gap-[16px]'>
                                <div className='flex-1 max-w-[150px]'>
                                </div>
                                {questionnaire?.options?.map((option, optionIndex) =>
                                    <div key={optionIndex} className='flex-1 flex justify-center items-center max-w-[150px]'>
                                        <div>{option?.text}</div>
                                    </div>
                                )}
                            </div>
                            {questionnaire?.rows?.map((row, rowIndex) =>
                                <div key={rowIndex} className='w-full flex flex-row gap-[16px]'>
                                    <div className='flex-1 max-w-[150px]'>
                                        {row?.text}
                                    </div>
                                    {questionnaire?.options?.map((option, optionIndex) =>
                                        <div key={optionIndex} className='flex-1 flex justify-center items-center max-w-[150px]'>
                                            <div>{row?.answers?.[optionIndex]|| 0}  ({Math.round(
                                                (row?.answers?.[optionIndex] || 0) / (row?.totalCount || 1) * 100
                                            )}%)</div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    }

                </div>
            )}





            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
